import { useSearchParams, Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { ShieldCheck, ArrowLeft } from "lucide-react";
import { LOGO_URL } from "@/lib/brand";

export default function Login() {
  const [params] = useSearchParams();
  const err = params.get("error");

  // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
  const handleLogin = () => {
    const redirectUrl = window.location.origin + "/admin";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center px-4">
      <div className="w-full max-w-md">
        <Link to="/" className="inline-flex items-center gap-1.5 text-sm text-slate-600 hover:text-slate-900 mb-6" data-testid="login-back">
          <ArrowLeft className="w-4 h-4" /> Back to site
        </Link>

        <div className="bg-white border border-slate-200 rounded-2xl p-8 shadow-sm">
          <div className="flex justify-center mb-5">
            <img src={LOGO_URL} alt="Loan81" data-testid="brand-logo" className="h-12 w-auto object-contain" />
          </div>

          <div className="text-center">
            <div className="inline-flex items-center gap-1.5 text-xs font-bold uppercase tracking-[0.2em] text-emerald-600 mb-2">
              <ShieldCheck className="w-3.5 h-3.5" /> Admin only
            </div>
            <h1 className="font-display text-2xl font-semibold text-slate-900">Sign in to continue</h1>
            <p className="text-sm text-slate-500 mt-1.5">Admin access is restricted to whitelisted Google accounts.</p>
          </div>

          {err && (
            <div className="mt-5 p-3 bg-red-50 border border-red-200 rounded-md text-sm text-red-700" data-testid="login-error">
              Login failed. Please try again.
            </div>
          )}

          <Button
            data-testid="login-google-button"
            onClick={handleLogin}
            className="w-full mt-6 h-12 bg-slate-900 hover:bg-slate-800 text-white font-semibold rounded-md active:scale-95 transition-all"
          >
            <svg className="w-5 h-5 mr-2" viewBox="0 0 24 24">
              <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/>
              <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
              <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/>
              <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/>
            </svg>
            Sign in with Google
          </Button>

          <p className="text-[11px] text-slate-500 text-center mt-4">
            By continuing you agree to Loan81 admin terms.
          </p>
        </div>
      </div>
    </div>
  );
}
